export default {
  INIT: 'USER/INIT',
  REGISTER_USER: 'USER/REGISTER_USER',
  CREATE_CUSTOMER: 'USER/CREATE_CUSTOMER',
}
